<template>
  <div></div>
</template>

<script>
export default {
  name: 'logout',
  data() {
    return {};
  },
  mounted() {
    if (this.$auth.isAuthenticated) {
      localStorage.removeItem(process.env.VUE_APP_AUTH_TOKEN || 'sideop-app-hermosillo');
      this.$auth.isAuthenticated = false;
      this.$auth.user = {};
      this.$router.push({ name: 'login' });
    } else {
      this.$router.push({ name: 'administracion' });
    }
  },
};
</script>

<style lang="scss">

</style>
